import * as React from 'react'
import {RowComponentProps} from '../../../../components/widgets/table/RowComponentProps';
import TableDeleteButton from '../../../../components/widgets/table/TableDeleteButton';
import EmployeeSuper from '../../api/EmployeeSuper';

const EmployeeSuperRow: React.FC<RowComponentProps<EmployeeSuper>> = ({item,
                                                                          onDeleteClick,
                                                                          entityName}) => {
  return <tr>
    <td>{item.displayName}</td>
    <td>{item.type}</td>
    <td>{item.stpType}</td>
    <td>{item.amount}</td>
    <td>
      <TableDeleteButton
        entityName={entityName}
        onDeleteClick={() => {
          onDeleteClick(item.id);
        }}
      />
    </td>
  </tr>;
};

export {EmployeeSuperRow};
